import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';
import { useState } from 'react';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import EFElectricGrill from 'elem/ui-assets/icons/appliances/EFElectricGrill';
import EFCoffeeMaker from 'elem/ui-assets/icons/appliances/EFCoffeeMaker';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';
import EfSection from '@elem/ui/ef-section';

interface IconType {
    icon: JSX.Element;
    text: string;
    num: string;
    unit: string;
}

interface ItemType {
    icons: IconType[];
    img: [string, string]; // [pc, h5]
    desc: string;
    name: string;
}

const JL: React.FC = () => {
    const { t } = useLang('delta3series');
    const { isH5 } = useMediaDevice();
    const items: ItemType[] = [
        {
            name: t('L_item1_name'),
            desc: t('L_item1_desc'),
            icons: [
                {
                    icon: <EFLight />,
                    text: t('L_item1_text1'),
                    num: t('L_item1_num1'),
                    unit: t('L_item1_unit1'),
                },
                {
                    icon: <EFPhone />,
                    text: t('L_item1_text2'),
                    num: t('L_item1_num2'),
                    unit: t('L_item1_unit2'),
                },
                {
                    icon: <EFFan />,
                    text: t('L_item1_text3'),
                    num: t('L_item1_num3'),
                    unit: t('L_item1_unit3'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('L_item1_text4'),
                    num: t('L_item1_num4'),
                    unit: t('L_item1_unit4'),
                },
                {
                    icon: <EFTV />,
                    text: t('L_item1_text5'),
                    num: t('L_item1_num5'),
                    unit: t('L_item1_unit5'),
                },
                {
                    icon: <EFWiFi />,
                    text: t('L_item1_text6'),
                    num: t('L_item1_num6'),
                    unit: t('L_item1_unit6'),
                },
                {
                    icon: <EFElectricGrill />,
                    text: t('L_item1_text7'),
                    num: t('L_item1_num7'),
                    unit: t('L_item1_unit7'),
                },
                {
                    icon: <EFCoffeeMaker />,
                    text: t('L_item1_text8'),
                    num: t('L_item1_num8'),
                    unit: t('L_item1_unit8'),
                },
            ],
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1741052947540/%E5%AE%B9%E9%87%8F%E6%8B%A1%E5%BC%B51%20(1).jpg',
                'https://websiteoss.ecoflow.com/upload/image/1741053073583/image%206%20(2).jpg',
            ],
        },
        {
            name: t('L_item2_name'),
            desc: t.rich('L_item2_desc', {
                a: (text: string) => (
                    <a href={t('link1')} target="_blank">
                        {text}
                    </a>
                ),
            }),
            icons: [
                {
                    icon: <EFLight />,
                    text: t('L_item2_text1'),
                    num: t('L_item2_num1'),
                    unit: t('L_item2_unit1'),
                },
                {
                    icon: <EFPhone />,
                    text: t('L_item2_text2'),
                    num: t('L_item2_num2'),
                    unit: t('L_item2_unit2'),
                },
                {
                    icon: <EFFan />,
                    text: t('L_item2_text3'),
                    num: t('L_item2_num3'),
                    unit: t('L_item2_unit3'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('L_item2_text4'),
                    num: t('L_item2_num4'),
                    unit: t('L_item2_unit4'),
                },
                {
                    icon: <EFTV />,
                    text: t('L_item2_text5'),
                    num: t('L_item2_num5'),
                    unit: t('L_item2_unit5'),
                },
                {
                    icon: <EFWiFi />,
                    text: t('L_item2_text6'),
                    num: t('L_item2_num6'),
                    unit: t('L_item2_unit6'),
                },
                {
                    icon: <EFElectricGrill />,
                    text: t('L_item2_text7'),
                    num: t('L_item2_num7'),
                    unit: t('L_item2_unit7'),
                },
                {
                    icon: <EFCoffeeMaker />,
                    text: t('L_item2_text8'),
                    num: t('L_item2_num8'),
                    unit: t('L_item2_unit8'),
                },
            ],
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1741053180171/%E5%AE%B9%E9%87%8F%E6%8B%A1%E5%BC%B52%20(1).jpg',
                'https://websiteoss.ecoflow.com/upload/image/1741053073398/%E5%9B%BE%E7%89%87%20(1).jpg',
            ],
        },
    ];
    const [active, setActive] = useState(items[0]);
    const [number, setNumber] = useState(0);

    const tabs: EcoTabItemProps[] = [
        {
            tabValue: '0',
            tabLabel: t('L_tab1'),
        },
        {
            tabValue: '1',
            tabLabel: t('L_tab2'),
        },
    ];

    return (
        <div className={styles.comp} id="d3-L">
            <EcoSpace />
            <EfSection label={t('L_label')} title={t('L_title')} />
            <EcoSpaceSmall />
            <div className="box">
                <div className="inner">
                    <div className="info">
                        <p className="desc">{active.desc}</p>
                        {isH5 && (
                            <div className="img-box">
                                <EcoImg pc={active.img[0]} h5={active.img[1]} />
                                <p className={`name name-${number}`}>{active.name}</p>
                            </div>
                        )}
                        <ul className="icons">
                            {active.icons.map((icon: IconType, k: number) => (
                                <li className="icon" key={k}>
                                    <div className="icon-svg">{icon.icon}</div>
                                    <p className="icon-text">{icon.text}</p>
                                    <div className="icon-suffix">
                                        <span className="icon-num">{icon.num}</span>
                                        <span className="icon-unit">{icon.unit}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {!isH5 && (
                        <div className="img-box">
                            <EcoImg pc={active.img[0]} h5={active.img[1]} />
                            <p className={`name name-${number}`}>{active.name}</p>
                        </div>
                    )}
                </div>
            </div>
            <EcoTab
                items={tabs}
                onChange={(_: EcoTabItemProps, k: number) => {
                    setActive(items[k]);
                    setNumber(k);
                }}
            />
        </div>
    );
};

export default JL;
